import { render } from "./loading.vue?vue&type=template&id=708c5232"
const script = {}
script.render = render

export default script